import React from "react";

import {
    ImportFormProps,
    IntegrationCategory,
    JudgmentIntegration,
    ExternalJudgmentImportCommand,
    SaveJudgmentIntegrationCommand,
    DeleteJudgmentIntegrationCommand,
} from "../types/JudgmentIntegrationTypes";
import * as yup from "yup";
import { FormikHelpers, useFormik } from "formik";
import { Button } from "primereact/button";
import { Panel } from "primereact/panel";
import judgmentStore from "../stores/judgment-store";
import { InputText } from "primereact/inputtext";
import { Message } from "primereact/message";
import { Calendar } from "primereact/calendar";
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';
import JudgmentClient from "../Api/judgment-client";
import judgmentClient from "../Api/judgment-client";

export const ExternalEditForm: React.FC<ImportFormProps> = function (props) {


    const nameHeaderFile = judgmentStore.currentIntegration?.integrationCategoryID === IntegrationCategory.Judgment ? "Judgment Integration Name:" : "Satisfaction Integration Name";

    const headerTemplate = () => {
        const headerText = judgmentStore.currentIntegration?.integrationCategoryID === IntegrationCategory.Judgment ? "Edit Imported Judgment Details" : "Edit Imported Satisfaction Details";

        const accept = () => {
            onDelete();
        }
        const confirmDelete = (event: { currentTarget: any; }) => {
            confirmPopup({
                target: event.currentTarget,
                message: 'Are you sure you want to delete this record?',
                icon: 'pi pi-info-circle',
                acceptClassName: 'p-button-danger',
                accept
            })
        }
        async function onDelete() {
            const judgmentIntegrationId: number = judgmentStore.currentIntegration.id;
            const judgmentIntegrationCommand: DeleteJudgmentIntegrationCommand = { judgmentIntegrationId };
            JudgmentClient.deleteJudgmentIntegration(judgmentIntegrationCommand);
            let response = await judgmentClient.getAllJudgementIntegrations();
            judgmentStore.judgmentIntegrations = response.judgmentIntegrations;
            judgmentStore.setInitialView();
            props.showToast("success", "Judgment successfully deleted", undefined, 5000);
        }
        function showDeleteButton() {
            if (judgmentStore.currentIntegration.statusID == 1 && judgmentStore.currentIntegration.canDeleteJudgmentIntegration == true)
            {
                return 'block';
            }
            else {
                return 'none'
            }
        }
        return (
            <>
                <ConfirmPopup />
                <div className="header">
                    <div className="title">{headerText}</div>

                    <Button
                        label="Delete"
                        type="button"
                        className="p-button-sm"
                        style={{
                            "width": "90px", "backgroundColor": "#dc3545", "borderColor": "#dc3545",
                            display: showDeleteButton()
                        }}
                        onClick={confirmDelete}
                    />

                    <Button
                        label="Save"
                        className="p-button-sm"
                        style={{ "width": "90px" }}
                    />

                </div>
            </>
        );
    };

    const formikProps = useFormik<ExternalJudgmentImportCommand>({
        initialValues: {
            judgmentIntegrationName: judgmentStore.currentIntegration
                ? judgmentStore.currentIntegration.name
                : "",
            startDateString: judgmentStore.currentIntegration ? new Date(judgmentStore.currentIntegration.startDate)
            .toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }) : null,
            startTimeString: judgmentStore.currentIntegration ? new Date(judgmentStore.currentIntegration.startDate)
            .toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true }) : null,
            endDateString: judgmentStore.currentIntegration ? new Date(judgmentStore.currentIntegration.endDate)
            .toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }) : null,
            endTimeString: judgmentStore.currentIntegration ? new Date(judgmentStore.currentIntegration.endDate)
            .toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true }) : null,
            integrationCategoryID:
                judgmentStore.currentIntegration?.integrationCategoryID,
            canDeleteJudgmentIntegration:
                judgmentStore.currentIntegration?.canDeleteJudgmentIntegration
        },
        validationSchema: yup.object().shape({
            judgmentIntegrationName: yup
                .string()
                .required("Integration name is required."),
            startDateString: yup
                .date()
                .nullable()
                .required("Start Date is required"),
            startTimeString: yup
                .date()
                .nullable()
                .required("Start Time is required"),
            endDateString: yup
                .date()
                .nullable()
                .required("End Date is required"),
            endTimeString: yup
                .date()
                .nullable()
                .required("End Time is required"),
        }),
        onSubmit: async (
            values: ExternalJudgmentImportCommand,
            { setSubmitting }: FormikHelpers<ExternalJudgmentImportCommand>
        ) => {
            const judgmentIntegration: JudgmentIntegration = judgmentStore.currentIntegration!;
            judgmentIntegration.name = values.judgmentIntegrationName;
            judgmentIntegration.startDate = new Date(`${values.startDateString} ${values.startTimeString}`);
            judgmentIntegration.endDate = new Date(`${values.endDateString} ${values.endTimeString}`);

            const command: SaveJudgmentIntegrationCommand = { judgmentIntegration };

            let response = await JudgmentClient.saveJudgmentIntegration(command);
            if (response.errors && response.errors.length > 0) {
                props.showToast(
                    "error",
                    response.message ?? "",
                    response.errors[0],
                    undefined,
                    true
                );
            } else {
                props.showToast("success", response.message ?? "", undefined, 5000);
                judgmentStore.currentIntegration = response.judgmentIntegration;
            }

            setSubmitting(false);
        },

        validateOnBlur: false,
        validateOnChange: false,
        enableReinitialize: true,

    });

    return (
        <form onSubmit={formikProps.handleSubmit}>
            <Panel header={headerTemplate}>

                <div className="p-fluid">
                    <div className="p-field p-grid">
                        <label htmlFor="judgmentIntegrationName" className="p-col-3 p-md-3 " >
                            {nameHeaderFile}
                        </label>
                        <div className="p-col-9 p-md-9">
                            <InputText
                                name="judgmentIntegrationName"
                                className={
                                    formikProps.errors.judgmentIntegrationName &&
                                        formikProps.touched.judgmentIntegrationName
                                        ? "p-invalid"
                                        : ""
                                }
                                value={formikProps.values.judgmentIntegrationName}
                                onChange={formikProps.handleChange}
                            />
                            {formikProps.errors.judgmentIntegrationName &&
                                formikProps.touched.judgmentIntegrationName && (
                                    <Message
                                        severity="error"
                                        text={formikProps.errors.judgmentIntegrationName}
                                    ></Message>
                                )}
                        </div>
                    </div>

                    <div className="p-field p-grid">
                        <div className="p-col-3 p-md-3">
                            <label htmlFor="startDate">Start Date and Time:</label>
                        </div>
                        <div className="p-col-3 p-md-3">
                            <Calendar
                                id="startDate"
                                name="startDate"
                                placeholder="Start Date"
                                dateFormat={"mm/dd/yy"}
                                value={formikProps.values.startDateString ? new Date(formikProps.values.startDateString) : null}
                                onChange={async (e) => {
                                    if (e) {
                                        formikProps.setFieldValue("startDateString", e.value);
                                    }
                                }}
                                className={
                                    formikProps.errors.startDateString && formikProps.touched.startDateString
                                        ? "p-invalid"
                                        : ""
                                }
                                showIcon
                                showButtonBar
                                monthNavigator
                                yearNavigator
                                yearRange="1950:2100"
                                disabled={judgmentStore.currentIntegration.statusID !== null}
                            />
                            {formikProps.errors.startDateString && formikProps.touched.startDateString && (
                                <Message
                                    severity="error"
                                    text={formikProps.errors.startDateString}
                                ></Message>
                            )}
                        </div>
                        <div className="p-col-3 p-md-3">
                            <Calendar
                                id="startTime"
                                name="startTime"
                                placeholder="Start Time"
                                value={formikProps.values.startTimeString ? new Date(formikProps.values.startTimeString) : null}
                                onChange={async (e) => {
                                    if (e) {
                                        formikProps.setFieldValue("startTimeString", e.value);
                                    }
                                }}
                                className={
                                    formikProps.errors.startTimeString && formikProps.touched.startTimeString
                                        ? "p-invalid"
                                        : ""
                                }
                                showIcon
                                showButtonBar
                                timeOnly
                                hourFormat="12"
                                disabled={judgmentStore.currentIntegration.statusID !== null}
                                //todayButtonClassName='time' //just keeping this for now, incase we want to change it later.
                            />
                            {formikProps.errors.startTimeString && formikProps.touched.startTimeString && (
                                <Message
                                    severity="error"
                                    text={formikProps.errors.startTimeString}
                                ></Message>
                            )}
                        </div>
                    </div>

                    <div className="p-field p-grid">
                        <div className="p-col-3 p-md-3">
                            <label htmlFor="endDate">End Date and Time:</label>
                        </div>
                        <div className="p-col-3 p-md-3">
                            <Calendar
                                id="endDate"
                                name="endDate"
                                placeholder="End Date"
                                dateFormat={"mm/dd/yy"}
                                value={formikProps.values.endDateString ? new Date(formikProps.values.endDateString) : null}
                                onChange={async (e) => {
                                    if (e) {
                                        formikProps.setFieldValue("endDateString", e.value);
                                    }
                                }}
                                className={
                                    formikProps.errors.endDateString && formikProps.touched.endDateString
                                        ? "p-invalid"
                                        : ""
                                }
                                showIcon
                                showButtonBar
                                monthNavigator
                                yearNavigator
                                yearRange="1950:2100"
                                disabled={judgmentStore.currentIntegration.statusID !== null}
                            />
                            {formikProps.errors.endDateString && formikProps.touched.endDateString && (
                                <Message
                                    severity="error"
                                    text={formikProps.errors.endDateString}
                                ></Message>
                            )}
                        </div>
                        <div className="p-col-3 p-md-3">
                            <Calendar
                                id="endTime"
                                name="endTime"
                                placeholder="End Time"
                                value={formikProps.values.endTimeString ? new Date(formikProps.values.endTimeString) : null}
                                onChange={async (e) => {
                                    if (e) {
                                        formikProps.setFieldValue("endTimeString", e.value);
                                    }
                                }}
                                className={
                                    formikProps.errors.endTimeString && formikProps.touched.endTimeString
                                        ? "p-invalid"
                                        : ""
                                }
                                showIcon
                                showButtonBar
                                timeOnly
                                hourFormat="12"
                                disabled={judgmentStore.currentIntegration.statusID !== null}
                                //todayButtonClassName='time' //just keeping this for now, incase we want to change it later.
                            />
                            {formikProps.errors.endTimeString && formikProps.touched.endTimeString && (
                                <Message
                                    severity="error"
                                    text={formikProps.errors.endTimeString}
                                ></Message>
                            )}
                        </div>
                    </div>

                </div>

            </Panel>
        </form>
    );
};
